import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/logo.svg";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar__left">
      
        <img src={logo} alt="logo"></img>
        <h1 className="navbar__name">Judith Matute</h1>
      </div>

      {/* Botón hamburguesa - solo visible en móvil */}
      <button
        className={`navbar__hamburger ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Menú de navegación */}
      <div className={`navbar__menu ${isMenuOpen ? "open" : ""}`}>
        <div className="navbar__center">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "nav-btn active" : "nav-btn"
            }
            onClick={closeMenu}
          >
            Home
          </NavLink>

          <NavLink
            to="/projects"
            className={({ isActive }) =>
              isActive ? "nav-btn active" : "nav-btn"
            }
            onClick={closeMenu}
          >
            Projects
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "nav-btn active" : "nav-btn"
            }
            onClick={closeMenu}
          >
            About me
          </NavLink>
        </div>

       
      </div>
 <div className="navbar__right">
          <a
            className="resume-link"
            href="/cv_judithmatute.pdf"
            target="_blank"
            onClick={closeMenu}
          >
            Resume ↗
          </a>
        </div>
      {/* Overlay para cerrar el menú */}
      {isMenuOpen && (
        <div className="navbar__overlay" onClick={closeMenu}></div>
      )}
    </nav>
  );
}
